var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.053 2.47 9.998.409A1.497 1.497 0 0 0 8.003.355L1.253 7.13a1.5 1.5 0 0 0-.427.91l-.323 3.14a.755.755 0 0 0 .462.764q.14.057.288.056h.068l3.127-.286c.343-.034.663-.186.908-.43l6.75-6.774a1.45 1.45 0 0 0-.053-2.04m-7.74 7.739-2.25.21.203-2.258 4.237-4.2 2.025 2.032zm5.19-5.224-2.01-2.018 1.463-1.505 2.047 2.055z"
  })));
};
export default SvgPencilIcon;